import React from "react";

export default function WorkflowPanel() {

  return (

    <div className="card mb-4">

      <div className="card-body">

        Workflow

      </div>

    </div>

  );

}